import { Typography } from "@mui/material";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import { DataGrid } from "@mui/x-data-grid";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SearchButton from "../../components/Buttons/SearchButton";
import CommonPagination from "../../components/CustomPagination/CommonPagination";
import strings from "../../config/localization";
import {
  useAddPermissionToRoleMutation,
  useGetAvailablePermissionsQuery,
} from "../../services/appln";
import { getRowsPerPage } from "../constants";

export default function PermissionSelectionPanel() {
  const navigate = useNavigate();
  const { roleId } = useParams();

  const [count, setCount] = useState(1);
  const [rowPerPage, setRowPerPage] = useState(getRowsPerPage());

  const [selectedRowIDs, setSelectedRowIDs] = useState<any>([]);
  const [searchTerm, setSearchTerm] = React.useState("");
  console.log("hhhhhhhhhhhhhhhhhhhh", selectedRowIDs);

  const getParams = {
    roleId: roleId,
    page: count,
    limit: rowPerPage,
    search: searchTerm,
  };

  const [addPermissions, addPermissionsParams] =
    useAddPermissionToRoleMutation();

  const { data, error, isLoading, isFetching } =
    useGetAvailablePermissionsQuery(getParams);

  const columns = [
    {
      field: "name",
      headerName: strings.name,
      width: 400,
    },
  ];

  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 5,
  });
  const handleChangePage = (event: any, value: any) => {
    setCount(value);
  };

  const handleChangeCount = (e: any) => {
    setRowPerPage(e.target.value);
  };

  return (
    <div>
      <Box sx={{ height: 400, width: "100%" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom component="div">
              {" "}
              {strings.selectPermissions}{" "}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {isLoading || isFetching ? (
              <Backdrop
                sx={{
                  color: "#fff",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open
              >
                <CircularProgress color="inherit" />
              </Backdrop>
            ) : null}
          </Grid>
          {error ? (
            <Grid item xs={12}>
              <Alert severity="error">
                <AlertTitle>{strings.error}</AlertTitle>
                {strings.failedToLoadPermissions}
              </Alert>
            </Grid>
          ) : null}
          <Grid item xs={12}>
            <SearchButton
              onClickHandler={(searchTerm: string) => {
                setCount(1);
                setSearchTerm(searchTerm);
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <div>
              <DataGrid
                columns={columns}
                rows={data?.data ? data?.data : []}
                checkboxSelection
                onRowSelectionModelChange={(newRowSelectionModel: any) => {
                  setSelectedRowIDs(newRowSelectionModel);
                }}
                rowSelectionModel={selectedRowIDs}
                keepNonExistentRowsSelected
              />
              <CommonPagination
                count={Math.ceil(data?.totalCount / rowPerPage)}
                page={count}
                handleChangePage={handleChangePage}
                rowPerPage={rowPerPage}
                handleChangeCount={handleChangeCount}
              />
            </div>
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              onClick={(e) => {
                addPermissions({
                  roleId: roleId,
                  permissionIds: Array.from(selectedRowIDs),
                });
                navigate(-1);
              }}
            >
              {strings.select}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
